import type { Deal } from '@/types'
import { getColumnMetrics } from './kanbanColumnMetrics'

export function getJourneyColumnMetrics(deals: Deal[]) {
  const base = getColumnMetrics(deals)
  const agingDays = deals.map((deal) => Math.max(0, deal.driftDays || 0))
  const maxAging = agingDays.length > 0 ? Math.max(...agingDays) : 0
  const atRisk = base.slaBreaches

  let statusLine = ''
  if (deals.length > 0) {
    statusLine =
      atRisk > 0
        ? `${atRisk} em risco · maior parada ${maxAging}d`
        : `Média ${base.avgAging}d na etapa`
  }

  return {
    ...base,
    maxAging,
    atRisk,
    statusLine,
  }
}

export type JourneyColumnMetrics = ReturnType<typeof getJourneyColumnMetrics>
